import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Slide.module.css';

import Fade from 'react-reveal/Fade';
import Pulse from 'react-reveal/Pulse';

const Slide = ({ title, description, linkText, image, url }) => {
  return (
    <div className={styles.Slide} style={{ backgroundImage: `url(${image})` }}>
      <Fade>
      <div>
        <h1>{title}</h1>
        <p>{description}</p>
        <div className={styles.link}>
          <div className={styles.ripple}><div></div><div></div></div>
            <Link to={url}><Pulse timeout={2000} delay={2000} forever>{linkText}</Pulse></Link>
        </div>
      </div>
      </Fade>
    </div>
  )
}

export default Slide
